<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">Drop-Off</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต
                        เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div style="padding: 0 20px">
                                <div ref="myDiv"
                                     style="display: flex;align-items: center;justify-content: space-between">
                                    <div :style="{width: divWidth*0.28 + 'px',height: divWidth*0.21 + 'px'}"
                                         style="border: 1px solid rgb(238, 238, 238);border-radius: 6px;display: flex;justify-content: center;align-items: center;position: relative">
                                        <div
                                            style="position: absolute;display: flex;justify-content: space-between;align-items: center;width: 100%;top: 0;padding: 5px;box-sizing: border-box">
                                            <div>累计收款</div>
                                            <b-button variant="link">查询收款记录</b-button>
                                        </div>
                                        <div style="font-size: 36px;color: #FF9845;font-weight: bold">
                                            {{ totalRebate }} ฿
                                        </div>
                                    </div>
                                    <div :style="{width: divWidth*0.7 + 'px'}">
                                        <el-carousel :height="divWidth*0.21 + 'px'">
                                            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                                                <img ref="bannerHeight" class="indexBannerImg" :src="item.img"
                                                     style="width: 100%">
                                            </el-carousel-item>
                                        </el-carousel>
                                    </div>
                                </div>
                                <div class="mt-5" style="display: flex;flex-wrap: wrap;justify-content: space-between"
                                     :style="{'flex-direction': divWidth > 800 ? '': 'column'}">
                                    <b-card
                                        header-tag="header"
                                        class="mb-2"
                                        v-for="(service, index) in dropOffServices"
                                        :key="index"
                                        :style="{'width': divWidth > 800 ? '49.5%': '100%'}"
                                        @click="goToService(service.title)"
                                    >
                                        <template #header>
                                            <h1 class="mb-0" style="font-weight:bolder;font-style: italic;">
                                                {{ service.title }}</h1>
                                            <div>{{ service.tips }}</div>
                                        </template>
                                        <div style="display: flex;justify-content: end;">
                                            <img :src="service.img" alt="" style="width: auto; height: 108px">
                                        </div>
                                    </b-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {
    getAgreementStatus,
    getCommissionAccount,
    isActiveDropoff,
    isReadNoticeDropoff,
    refundTotalFee
} from "@/api/dropOff";

export default {
    name: "",
    data() {
        return {
            dropOffServices: [
                {
                    title: 'FLASH',
                    tips: 'Drop-off New Service',
                    img: require('@/assets/images/newImg/mysave-flash-logo.jpg'),
                },
                {
                    title: 'LAZADA',
                    tips: 'Drop-off New Service',
                    img: require('@/assets/images/newImg/lazada-logo.png'),
                },
                {
                    title: 'KERRY',
                    tips: 'Drop-off New Service',
                    img: require('@/assets/images/newImg/dropoff-kerry-logo.jpeg'),
                }
            ],
            totalRebate: 0,
            divWidth: 1200,
            busy: false,
            bannerList: [
                {
                    id: 1,
                    img: require('@/assets/images/newImg/dropoff-banner.jpeg')
                },
                {
                    id: 2,
                    img: require('@/assets/images/newImg/dropoff-banner1.jpeg')
                },
            ],
            express: '',
            dropoffRegisterUrl: '',
            fullscreenLoading: false,
            dropoffNoticeDialogVisible: false,
        }
    },
    created() {
        this.refundTotalFee();
    },
    mounted() {
        this.updateDivWidth();
        window.addEventListener('resize', this.updateDivWidth);
    },
    methods: {
        goToService(title) {
            this.express = title
            if (title === 'FLASH') {
                this.dropoffRegisterUrl = 'https://forms.gle/qQs3RWEuLeWRuxzp8'
            } else if (title === 'LAZADA') {
                this.dropoffRegisterUrl = 'https://shorturl.asia/1aMvE'
            } else if (title === 'KERRY') {
                this.dropoffRegisterUrl = 'https://forms.gle/djbJvwfGt4kTrcvy9'
            }
            this.fullscreenLoading = true;
            this.fnHasDropOffAgent()
        },
        fnHasDropOffAgent() {
            isActiveDropoff({
                platform: this.express
            })
                .then((res) => {
                    if (res.data === false) {
                        const h = this.$createElement;
                        this.$msgbox({
                            title: '温馨提示',
                            customClass: 'msgbox',
                            showClose: false,
                            message: h('p', null, [
                                h('span', null, 'คุณยังไม่ได้สมัครใช้งาน โปรดติดต่อฝ่ายบริการ'),
                                h('br', null, ''),
                                h('br', null, ''),
                                h('span', null, 'หรือลงทะเบียนผ่านลิงก์นี้'),
                                h('br', null, ''),
                                h('a', {
                                    style: 'color: rgb(72, 128, 239)',
                                    attrs: {href: this.dropoffRegisterUrl, target: '_blank'}
                                }, this.dropoffRegisterUrl,),
                                h('br', null, ''),
                                h('span', null, 'สำหรับสมาชิกใหม่ ที่สมัครแฟรนไชส์หลังวันที่ 15 มิถุนายน 2566'),
                                h('br', null, ''),
                                h('span', null, 'การยืนยันจะใช้เวลา 1-3 สัปดาห์ในการลงทะเบียนระบบ'),
                            ]),
                            confirmButtonText: '关闭',
                        }).then(action => {
                            this.fullscreenLoading = false;
                            return action
                        });
                    } else {
                        if (this.express !== 'LAZADA') {
                            return this.fnDropoffNotice()
                        } else {
                            return this.fnGetCommissionAccount()
                        }
                    }
                })
                .catch((err) => {
                    this.fullscreenLoading = false
                    console.log(err);
                })
        },
        fnDropOffQuery() {
            getAgreementStatus({
                platform: this.express
            })
                .then((res) => {
                    console.log(res);
                    if (res.data.code !== 200) {
                        this.fullscreenLoading = false
                        return this.$message.error(res.data.msg)
                    }
                    if (res.data.data) {
                        return this.fnGetCommissionAccount()
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '您尚未激活签约Drop-Off服务',
                            customClass: "messageClass"
                        });
                        this.agreementDialogVisible = true
                    }
                })
                .catch((err) => {
                    this.fullscreenLoading = false
                    console.log(err);
                })
        },
        fnDropoffNotice() {
            // 查询是否阅读公告
            isReadNoticeDropoff({
                platform: this.express
            })
                .then((res) => {
                    console.log(res)
                    if (res.data.code !== 200) {
                        return this.$message.error(res.data.msg)
                    }
                    if (res.data.data) {
                        return this.fnDropOffQuery()
                    } else {
                        this.dropoffNoticeDialogVisible = true
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            //       this.fnDropOffQuery()
        },
        // 查询佣金账户信息
        fnGetCommissionAccount() {
            getCommissionAccount()
                .then((res) => {
                    if (res.data.data && res.data.data.length === 0) {
                        this.$confirm('您尚未设置佣金收款账户，是否去设置？', '收款账户未设置', {
                            confirmButtonText: '去设置',
                            cancelButtonText: '已取消设置',
                            type: 'warning'
                        }).then(() => {
                            if (res.data.code !== 200) {
                                this.fullscreenLoading = false
                                return this.$message.error(res.data.msg)
                            }
                            this.setUpAccount()
                        }).catch(() => {
                            this.fullscreenLoading = false
                            this.$message({
                                type: 'info',
                                message: '已取消设置'
                            });
                        });
                    } else {
                        if (this.express === 'FLASH') {
                            this.$router.push({path: '/DropOff/flash'})
                        } else if (this.express === 'LAZADA') {
                            this.$router.push({path: '/DropOff/lazada'})
                        } else if (this.express === 'KERRY') {
                            this.$router.push({path: '/DropOff/kerry'})
                        }
                    }
                })
                .catch((err) => {
                    this.fullscreenLoading = false
                    console.log(err);
                })
        },
        refundTotalFee() {
            this.busy = true;
            refundTotalFee().then(res => {
                this.busy = false;
                this.totalRebate = res.data.total.toFixed(2)
            }).catch(err => {
                this.busy = false;
            })
        },
        updateDivWidth() {
            if (this.$refs.myDiv) {
                this.divWidth = this.$refs.myDiv.offsetWidth;
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateDivWidth);
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
